import { Switch } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import React from "react";
import { useUserData } from "../../../auth/useUserData.js";
import {
  FilterByBoolean,
  FilterByEnum,
  FilterByEnumProps,
  FilterByNumber,
  FilterByText,
  FilterProps,
} from "../../../commons/filters/index.js";
import type { Filters } from "../ProjectsList.js";
import { ProjectFilterPlanning } from "./ProjectPlanning.js";
export {
  ProjectCategoryFilter as FilterProjectCategory,
  ProjectCategoryFilterChips as FilterProjectCategoryChips,
} from "./ProjectCategory.js";
export { ProjectsSorting } from "./ProjectSorting.js";
export {
  ProjectStatesSelect as FilterProjectState,
  ProjectStatesFilterChips as FilterProjectStateChips,
} from "./ProjectState.js";
export {
  ProjectTypesFilter as FilterProjectType,
  ProjectTypesFilterChips as FilterProjectTypeChips,
} from "./ProjectType.js";

export const FilterBuildingZip = (props: FilterProps<string>) => {
  const { t } = useTranslate("Projects");
  return (
    <FilterByText
      label={t("ZIP")}
      placeholder={t("Enter zipcode")}
      {...props}
    />
  );
};

export const FilterWithinRadiusKm = (
  props: FilterProps<number> & { label?: string }
) => {
  const { t } = useTranslate("Projects");
  return (
    <FilterByNumber
      label={props.label || `${t("Proximity")} (${t("in km; 0 = any")})`}
      placeholder={t("e.g. 40")}
      // helperText={t("in km; 0 = any")}
      {...props}
    />
  );
};

export const FilterMinBudget = (props: FilterProps<number>) => {
  const { t } = useTranslate("Projects");
  return (
    <FilterByNumber
      label={`${t("Minimum Budget")} (${t("in EUR; 0 = any")})`}
      placeholder={t("e.g. 10000")}
      // helperText={t("in EUR; 0 = any")}
      {...props}
    />
  );
};

export const FilterPlanningState = (
  props: Pick<
    Extract<FilterByEnumProps<ProjectFilterPlanning>, { type: "many" }>,
    "value" | "setValue"
  >
) => {
  const { t } = useTranslate(["Projects"]);
  const labels: Record<ProjectFilterPlanning, string> = {
    PLANNED: t("Planned", { ns: "Projects" }),
    UNPLANNED: t("Unplanned", { ns: "Projects" }),
  };

  return (
    <FilterByEnum
      label={t("Planning")}
      type="many"
      anyEnum={{
        PLANNED: "PLANNED",
        UNPLANNED: "UNPLANNED",
      }}
      getOptionLabel={value => labels[value]}
      value={props.value}
      setValue={props.setValue}
    />
  );
};

export function FilterRelevantToMe<F extends Filters>({
  filters,
  setFilters,
}: {
  filters: F;
  setFilters: React.Dispatch<React.SetStateAction<F>>;
}) {
  const { t } = useTranslate(["Opportunities"]);
  const viewer = useUserData().currentUser!;
  return (
    <Switch
      label={t("Relevant to me", { ns: "Opportunities" })}
      checked={Boolean(
        filters.filterRelevantToUserIds &&
        filters.filterRelevantToUserIds.length > 0 &&
        filters.filterRelevantToUserIds.includes(viewer.id)
      )}
      onChange={(_, checked) => {
        setFilters(filters => {
          let newRelevantIds = [...(filters.filterRelevantToUserIds ?? [])];
          if (checked) {
            if (!newRelevantIds.includes(viewer.id))
              newRelevantIds.push(viewer.id);
          } else {
            if (newRelevantIds.includes(viewer.id))
              newRelevantIds = newRelevantIds.filter(id => id !== viewer.id);
          }
          return {
            ...filters,
            filterRelevantToUserIds:
              newRelevantIds.length > 0 ? newRelevantIds : undefined,
          };
        });
      }}
    />
  );
}
